export enum AuthRouteKeys {
  Root = '/auth',
  Login = '/auth/login',
  OTP = '/auth/otp',
  NewPassword = '/auth/new-password',
  NewPasswordVerifByEmail = '/auth/new-password-verify-by-email',
}

export enum ErrorRouteKeys {
  Root = '/error',
  NotFound = '/error/404',
  Internal = '/error/500',
  NotAccess = '/error/403',
}

export enum MainRouteKeys {
  Root = '/',
  Personal = '/personal',
  PersonalInfo = '/personal/info',
  PersonalFinancialLimits = '/personal/financial-limits',
  PersonalTwoFaSecurity = '/personal/two-fa-security',
  PersonalBalance = '/personal/balance',
  DepositFromMoraPay = '/personal/reward/deposit-from-morapay',
  WithdrawToMoraPay = '/personal/reward/withdraw-to-morapay',
  PersonalChangePassword = '/personal/change-password',
  PersonalLogout = '/personal/logout',
  Users = '/users',
  UpdateUser = '/update-user',
  Balance = '/balance',
  BalanceManage = '/balance/manage',
  Transfers = '/balance/transfers',
  TopUp = '/balance/topup',
  // TransfersToBank = '/balance/transfers-to-bank',
  TransfersToBankBIDV = '/balance/transfers-to-bank-bidv',
  Transactions = '/transactions',
  PointTransactions = '/transactions/points',
  PointTransactionDetails = '/transactions/points/:transactionCode',
  RequestWithdraw = '/request-withdraw',
  BankManagement = '/request-withdraw/bank-management',
  RequestWithdrawOwn = '/request-withdraw/request-withdraw-own',
  RequestWithdrawOwnDetail = '/request-withdraw/request-withdraw-own/:id',
  CheckRequestWithdrawList = '/request-withdraw/check-request-withdraw',
  CheckRequestWithdrawDetail = '/request-withdraw/check-request-withdraw/:id',
  CreateRequestWithdraw = '/request-withdraw/create-request-withdraw',
  CompanyDepartment = '/company-department',
  Company = '/company-department/company',
  EInvoiceAccount = '/company-department/einvoice-account',
  MerchantCredential = '/company-department/merchant-credential',
  AuditLogsAdmin = '/audit-logs-admin',
  BidvVirtualAccount = '/bidv-virtual-account',
  BidvVirtualAccountInquiry = '/bidv-virtual-account/inquiry',
  BidvTransHistory = '/bidv-virtual-account/trans-history',
  // BIDV Bank Transfer Routes
  BidvBankTransfer = '/bidv-bank-transfer',
  BidvBankTransferReconciliation = '/bidv-bank-transfer/reconciliation',
  BidvBankTransferWhitelist = '/bidv-bank-transfer/whitelist',
  BidvEkycGuide = '/bidv-bank-transfer/ekyc-guide',
  BidvTransferDestWhitelist = '/bidv-bank-transfer/dest-whitelist',
  // BIDV Transfer With Evidence Routes
  BidvTransferWithEvidence = '/bidv-transfer-with-evidence',
  BidvTransferWithEvidenceCreate = '/bidv-transfer-with-evidence/transfer-with-evidence/create',
  BidvTransferWithEvidenceOwn = '/bidv-transfer-with-evidence/own',
  BidvTransferWithEvidenceAll = '/bidv-transfer-with-evidence/all',
  BidvTransferWithEvidenceDetails = '/bidv-transfer-with-evidence/details/:id',
  Settings = '/settings',
  AppVersionConfig = '/settings/app-version',
  UnlockSmsRateLimit = '/settings/unlock-sms-rate-limit',
  BalanceOperationControls = '/settings/balance-operation-controls',
}

export const MainRouteHelpers = {
  transactionDetail: (id: string) => `/transaction/${id}`,
  requestWithdrawOwnDetail: (id: string) =>
    `/request-withdraw/request-withdraw-own/${id}`,
  checkRequestWithdrawDetail: (id: string) =>
    `/request-withdraw/check-request-withdraw/${id}`,
};
